const profileSettings = {
  title: 'Account Settings',
  subtitle: 'Manage your recruiting profile, connected accounts, and subscription status.',
  navigationLabel: 'Account settings navigation',
  profileCardTitle: 'Profile Information',
  profileCardDesc: 'Keep these details current for recruiting collaboration and account identity.',
  accountCardTitle: 'Account & Login',
  accountCardDesc: 'Review your signed-in account and manage password access.',
  socialCardTitle: 'Connected Accounts',
  socialCardDesc: 'Connected providers can be used for login and recruiting workflows.',
  preferencesCardTitle: 'Preferences',
  preferencesCardDesc: 'Manage language switching and the website user center entry.',
  pointsCardTitle: 'User Points',
  pointsCardDesc: 'Review the remaining contact points and AI Credits in your account.',
  planCardTitle: 'Plan & Subscription',
  planCardDesc: 'Review your current membership and auto-renew status.',
  fields: {
    hiringCompany: 'Current Company Name',
    identity: 'Identity',
    name: 'Name',
    title: 'Title',
    linkedinAccountType: 'Current LinkedIn Account Type',
    contact: 'Contact',
    email: 'Login Email',
    password: 'Account Password',
    language: 'Interface Language',
    userCenter: 'User Center',
  },
  placeholders: {
    hiringCompany: 'Enter your current company name',
    name: 'Enter your name',
    title: 'Enter your title',
    linkedinAccountType: 'Select a LinkedIn account type',
    contact: 'For example: wechat: xxx / email: xxx',
  },
  identityOptions: {
    hr: 'HR',
    headhunter: 'Headhunter',
  },
  linkedinAccountTypes: {
    business: 'Business',
    sales: 'Sales',
    recruiter: 'Recruiter',
    personal: 'Personal',
  },
  sections: {
    work: 'Work Information',
    workDesc: 'Identify the recruiting team you currently work with.',
    identity: 'Personal Identity',
    identityDesc: 'Tell us how to address you and your recruiting role.',
    recruiting: 'Recruiting Account',
    recruitingDesc: 'Add your LinkedIn context and preferred contact details.',
  },
  actions: {
    save: 'Save Profile',
    edit: 'Edit Profile',
    complete: 'Complete Profile',
    cancel: 'Cancel',
    retry: 'Reload',
    changePassword: 'Change Password',
    manageBilling: 'Open Pricing',
    openUserCenter: 'Open User Center',
  },
  languages: {
    zhCN: '简体中文',
    en: 'English',
  },
  userCenter: {
    title: 'Website User Center',
  },
  empty: {
    title: 'Complete your profile',
    desc: 'Add your company, name, and LinkedIn account type for a more accurate recruiting experience.',
  },
  incomplete: {
    title: 'Profile incomplete',
    desc: 'Some required details are missing. Complete them to unlock the full recruiting experience.',
  },
  loadError: {
    title: 'Profile could not be loaded',
    desc: 'Your profile is temporarily unavailable. Reload it before making changes.',
  },
  status: {
    loading: 'Loading...',
    notProvided: 'Not provided',
    linked: 'Linked',
    notLinked: 'Not linked',
    freePlan: 'Free Plan',
    passwordProtected: 'Protected with an account password',
  },
}

export default profileSettings
